import styled from 'styled-components';
import { DashboardLayout } from '../../../components/layout';
import { claude } from '../tokens';

// Every other dashboard page wraps itself in <DashboardLayout> (sidebar + header
// chrome); the Agents pages previously didn't, so they rendered chrome-less.
// The Claude-styled surface is deliberately scoped to an "island" card inside
// the normal dashboard content area, rather than a full-bleed sheet that
// clashes with the rest of the app.
//
// Since 2026-09-24 (spec §7) the island takes its palette from the --odin-*
// variables, so it follows the header's light/dark toggle like every other
// page, and antd styling comes from the root ConfigProvider in App.jsx. The
// former `dark` prop is accepted and ignored so existing callers keep working
// until they are swept.
const Outer = styled.div`
  max-width: 980px;
  margin: 0 auto;
  padding: 4px 4px 56px;
`;

const Island = styled.div`
  background: ${claude.bg};
  border: 1px solid ${claude.border};
  border-radius: ${claude.radiusLg};
  padding: 40px;
  font-family: ${claude.fontSans};
  color: ${claude.textPrimary};
  box-shadow: 0 2px 14px rgba(0, 0, 0, 0.18);
`;

export default function PageContainer({ children }) {
  return (
    <DashboardLayout>
      <Outer>
        <Island>{children}</Island>
      </Outer>
    </DashboardLayout>
  );
}
